import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import IconReusable from '../../../components/IconReusable';
import { getCategoryConfig } from '../config/questionsConfig';
import { renderContent } from './SingleQuestion';
import { ProfilerQuestionID } from '../config/QuestionEnum';
import { MaritalStatusEnum } from '../config/Profiler_enum';

const MARITAL_DEPENDENT_QUESTION_IDS = [
  ProfilerQuestionID.MARRIAGE_ANNIVERSARY,
  ProfilerQuestionID.SPOUSE_BUSINESS_INVOLVEMENT,
];

const MultiQuestionCard = ({ group, onEdit }) => {
  const categoryConfig = getCategoryConfig(group.category);
  const title = categoryConfig?.title || group.title;
  const image = categoryConfig?.image;
  const subtitle = categoryConfig?.subtitle;
  const isMobile = useMediaQuery("(max-width: 1200px)");
  const maritalStatusIdx = group.ids.indexOf(ProfilerQuestionID.MARITAL_STATUS);
  const isMarried =
    maritalStatusIdx !== -1 &&
    group.values[maritalStatusIdx] === MaritalStatusEnum.MARRIED;
  return (
    <Box sx={{ background: '#fff', borderRadius: 2, p: 2, width: '100%',  gap: 1 , display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h2">{title}</Typography>
        <IconReusable name="Edit" width={isMobile ? 16 : 24} height={isMobile ? 16 : 24}onClick={() => onEdit(group)} />
      </Box>

      {(image || subtitle) && (
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1 }}>
          {image && (
            <Box
              component="img"
              src={image}
              alt={title}
              width={{ xs: '40px', md: '70px' }}
            />
          )}
          {subtitle && (
            <Typography variant="p3">{subtitle}</Typography>
          )}
        </Box>
      )}

      {group.ids.map((id, idx) => {
        if (MARITAL_DEPENDENT_QUESTION_IDS.includes(id) && !isMarried) {
          return null;
        }
        return (
          <Box key={id} sx={{ mb: 1, display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="labelD">
              {group.configs[idx]?.question}
            </Typography>
            <Box>
              {renderContent(group.values[idx], () => onEdit(group))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default MultiQuestionCard;
